// extracted by mini-css-extract-plugin
export default {"header":"Result_header__lglUQ","cat-title":"Result_cat-title__o8CNq","solutions":"Result_solutions__Ara57","card":"Result_card__nQQWe"};